class Global {

  static getServerDomain() {
    switch (process.env.NODE_ENV) {
      case 'production':
        return 'https://swampum.com/api'
      case 'development':
        return 'http://api.swampum.dokku.d20labs.com.br'
      case 'test':
        return 'http://test.swampum.dokku.d20labs.com.br'
      case 'local':
        return 'http://localhost:3000'
      case 'aws':
        return 'https://swampam.com/api'
    }
  }
  static getFrontDomain() {
    switch (process.env.NODE_ENV) {
      case 'production':
        return 'https://swampum.com'
      case 'development':
        return 'http://swampum.dokku.d20labs.com.br'
      case 'test':
      case 'local':
        return 'http://localhost:8080'
      case 'aws':
        return 'https://swampam.com'
    }
  }

  static getGroupPicture(id) {
    return Global.getServerDomain() + '/images/group/' + id + '.jpg'
  }

  static getUserPicture(id) {
    return Global.getServerDomain() + '/images/user/' + id + '.jpg'
  }

  static getItemPicture(id) {
    return Global.getServerDomain() + '/images/item/' + id + '.jpg'
  }

  static getUserName(user) {
    if (user.firstName) {
      return user.firstName
    } else {
      return user.username
    }
  }

  static checkDevice() { 
    return navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i);
  }
}

export default Global
